import CreateSupplierSidePanel from 'src/sections/supplier/CreateSupplierSidePanel';
import { useCallback } from 'react';
import { useContextSelector } from 'use-context-selector';
import { SuppliersContext } from './SuppliersContext';

const CreateSupplierSidePanelContainer = () => {
  const isCreateSupplierPanelOpen = useContextSelector(
    SuppliersContext,
    (context) => context.isCreateSupplierPanelOpen
  );
  const closeCreateSupplierPanel = useContextSelector(
    SuppliersContext,
    (context) => context.closeCreateSupplierPanel
  );
  const handleSaveSuccess = useCallback(() => {
    closeCreateSupplierPanel();
  }, [closeCreateSupplierPanel]);

  return (
    <CreateSupplierSidePanel
      isOpen={isCreateSupplierPanelOpen}
      onClose={closeCreateSupplierPanel}
      onSaveSuccess={handleSaveSuccess}
    />
  );
};

export default CreateSupplierSidePanelContainer;
